// frontend/admin-portal/src/routes/domains/authRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import Login from "../../pages/Login";
import Unauthorized from "../../pages/Unauthorized";

export default function AuthRoutes() {
  return (
    <>
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
    </>
  );
}
